import { render, staticRenderFns } from "./time-range.vue?vue&type=template&id=fb28660e&"
import script from "./time-range.vue?vue&type=script&lang=js&"
export * from "./time-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb28660e')) {
      api.createRecord('fb28660e', component.options)
    } else {
      api.reload('fb28660e', component.options)
    }
    module.hot.accept("./time-range.vue?vue&type=template&id=fb28660e&", function () {
      api.rerender('fb28660e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/date-picker/src/panel/time-range.vue"
export default component.exports